/* eslint-disable */
import { Component, OnInit, Type, ViewChild } from '@angular/core';
import { ModalController, NavParams, Platform } from '@ionic/angular';
import { GoogleMapsController } from 'src/app/components/map/google-map/controllers/google-maps.controller';
import { GoogleMapsComponent } from 'src/app/components/map/google-map/google-maps.component';
import { GoogleMapsState } from 'src/app/components/map/google-map/google-maps.state';
import { MSMapType } from 'src/app/models/map.model';
import { CONSTANTS } from 'src/app/services/config.service';
import { GisService } from 'src/app/services/gis.service';
import { LoggerService } from 'src/app/services/logger.service';
import { MapsService } from 'src/app/services/maps.service';
import { PointsHelperService } from 'src/app/services/points-helper.service';
import { identifyPlatform, PlatformEnum } from 'src/app/utils/platform.utils';
import { SurveyMapBrowserPage } from '../browser/survey-map-browser.page';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';

@Component({
  selector: 'app-survey-map',
  templateUrl: './survey-map.page.html',
  styleUrls: ['./survey-map.page.scss']
})
export class SurveyMapPage implements OnInit {
  @ViewChild(GoogleMapsComponent) map: GoogleMapsComponent;

  data: any = {};
  points: any = [];
  mapLoaded: boolean;
  mapTab = 'overview';
  START_STOP_ZOOM = 7;

  constructor(
    private navParams: NavParams,
    public modalCtrl: ModalController,
    private logger: LoggerService,
    private gis: GisService,
    private maps: MapsService,
    private pointsHelper: PointsHelperService
  ) {}

  async setBounds(center, radiusMeters) {
    const latDelta = this.gis.getLatDegrees(radiusMeters);
    const north = { lat: center.lat + latDelta, lng: center.lng };
    const south = { lat: center.lat - latDelta, lng: center.lng };
    await this.maps.setMapBounds([north, center, south]);
  }

  /************************************************************************************************************************************************************************
   * SET MAP VIEW
   ***********************************************************************************************************************************************************************/

  async showStart() {
    if (!this.data.isLongDistance) {
      await this.maps.showPoint(this.points[0]);
    } else {
      await this.setBounds(this.points[0], CONSTANTS.tripRecording.GEOFENCE_RADIUS * 1.5);
    }
  }

  async showStop() {
    if (!this.data.isLongDistance) {
      await this.maps.showPoint(this.points[this.points.length - 1]);
    } else {
      await this.setBounds(this.points[this.points.length - 1], CONSTANTS.tripRecording.DWELL_METERS * 1.5);
    }
  }

  async showOverview() {
    if (!this.data.isLongDistance) {
      await this.maps.setMapType(MSMapType.NORMAL);
    }
    await this.maps.showOverview(null, this.data.survey.addedTripType === 'LOOP');
  }

  /************************************************************************************************************************************************************************
   * NAVIGATE
   ***********************************************************************************************************************************************************************/

  dismiss() {
    this.maps.removeMap().then(() => {
      this.modalCtrl.dismiss();
    });
  }

  async init(controller: GoogleMapsController) {
    this.logger.log('ionViewDidLoad MapSurveyPage', MSRemoteLoggerCategory.SURVEY_MAP_DEVICE_PAGE);
    this.data = this.navParams.data;
    await this.pointsHelper
      .getPoints(this.data.earlier, this.data.survey, this.data.isLongDistance, false)
      .then(async (res) => {
        this.points = res.locations;
        return await this.maps.init(controller, this.points[0], this.points);
        // return this.maps.init(this.mapElement.nativeElement, this.pleaseConnect.nativeElement, this.points[this.points.length-1], this.points);
      })
      .then(async () => {
        if (this.data.isLongDistance) {
          return await this.maps.addCirclesAndMarkers(this.points, this.data.survey);
        } else {
          return await this.maps.addMarkersAndPath(this.points, this.data.survey);
        }
      })
      .then(async () => {
        await this.showOverview();

        this.mapLoaded = true;
        if (this.data.isLongDistance) {
          this.mapTab = 'stop';
          await this.showStop();
        } else {
          this.mapTab = 'overview';
          // this.showOverview();
        }
      })
      .catch((err) => {
        this.logger.log('****MAP ERROR****', MSRemoteLoggerCategory.SURVEY_MAP_DEVICE_PAGE, err);
      });
  }

  ionViewDidEnter() {
    this.map.setUp();
    this.map.initiateMap(false);
  }

  ngOnInit() {}

  async ionViewWillLeave() {
    await this.maps.removeMap(true);
    await this.map.tearDown();
  }

  async mapStateUpdate(state: GoogleMapsState.Spec) {
    if (state instanceof GoogleMapsState.Ready) {
      const controller = state.controller;

      await this.init(controller);
    }
  }

  static selectSurveyMapPage(platform: Platform): Type<SurveyMapPage> | Type<SurveyMapBrowserPage> {
    const isBrowserMove = identifyPlatform(platform) === PlatformEnum.BROWSER;
    return isBrowserMove ? SurveyMapBrowserPage : SurveyMapPage;
  }
}
